import popupStyles from "./privacyProtectionPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { ChangeEvent, useState } from "react";
import { useLazyConfirmAccessToUsersQuery } from "../../../services/api/utils.api";
import { tWithKeyAttr as t } from "../../../i18nHelper";


function PrivacyProtectionPopup({
  onClose,
  clientUsersGuid,
}: IPopupWithoutProps & { clientUsersGuid: string | number }) {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [error, setError] = useState("");

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
  };
  const [confirmAccess] = useLazyConfirmAccessToUsersQuery();
  const sendConfirmation = () => {
    confirmAccess({ clientUsersGuid })
      .then((res) => {
        if (res && "data" in res) {
          onClose();
        }
      })
      .catch((err) => {
        setError(err);
        console.log(err);
      });
  };
  return (
    <article className={popupStyles.popup} data-testid="privacy-protection-popup">
      <h2 className={popupStyles.popup__title}>{t('PRIVACY_PROTECTION_DECLARATION')}</h2>
      <img
        src={doctor}
        alt={t('IMAGE_OF_VENUS')}
        className={popupStyles.popup__img}
      />
      <p className={popupStyles.popup__text}>
        {t('PRIVACY_POLICY_COMMITMENT')}</p>
      <p className={popupStyles.popup__text}>
        {t('PATIENT_MEDICAL_INFO_ACCESS')}</p>
      <p className={popupStyles.popup__text}>
        {t('PATIENT_PRIVACY_IMPORTANCE')}</p>
      <label className={popupStyles.popup__text} htmlFor={"confirm"}>
        <input
          id={"confirm"}
          data-testid="privacy-confirm-checkbox"
          name={"confirm"}
          type="checkbox"
          checked={isChecked}
          onChange={handleCheckboxChange}
        />{t('I_CONFIRM')}</label>
      {error && <p className={`error`}>{error}</p>}
      <button
        type={"button"}
        className={`button hover ${popupStyles.popup__nextBtn} ${
          !isChecked && popupStyles.popup__nextBtn_disabled
        }`}
        data-testid="privacy-confirm-button"
        onClick={sendConfirmation}
        disabled={!isChecked}
      >
        {t('CONTINUE_1')}</button>
    </article>
  );
}

export default PrivacyProtectionPopup;
